module.exports = "/assets/landing-dw/instagram/facebook.png?GWsvhKF";